module.exports = __webpack_public_path__ + "img/gotoko.5f968623.webp";